import { render, staticRenderFns } from "./StatsBuilderTables.vue?vue&type=template&id=0ab840fc"
import script from "./StatsBuilderTables.vue?vue&type=script&lang=js"
export * from "./StatsBuilderTables.vue?vue&type=script&lang=js"
import style0 from "./StatsBuilderTables.vue?vue&type=style&index=0&id=0ab840fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports